<div style="display: inline-block; margin-top: 1px">
    <span style="margin-right: 15px">
        <div class="legend-1"></div>
        &lt; 2% Change
    </span>
    <span style="margin-right: 15px">
        <div class="legend-2"></div>
        2% - 5% Change
    </span>
    <span style="margin-right: 15px">
        <div class="legend-3"></div>
        5% - 8% Change
    </span>
    <span>
        <div class="legend-4"></div>
        &gt; 8% Change
    </span>
</div>
<plotly-plot
    [data]="graph.data"
    (plotlyClick)="handleTreemapClick($event)"
    [layout]="graph.layout"
    [config]="graph.config"
></plotly-plot>
